var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithubLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "96px",
    viewBox: "0 0 1.92 1.92",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.957 0A0.957 0.957 0 0 0 0 0.957c0 0.423 0.276 0.781 0.652 0.91 0.047 0.006 0.065 -0.024 0.065 -0.047v-0.164c-0.264 0.059 -0.323 -0.129 -0.323 -0.129 -0.041 -0.112 -0.106 -0.141 -0.106 -0.141 -0.088 -0.059 0.006 -0.059 0.006 -0.059 0.094 0.006 0.147 0.1 0.147 0.1 0.088 0.147 0.223 0.106 0.276 0.082 0.006 -0.065 0.035 -0.106 0.059 -0.129 -0.211 -0.024 -0.435 -0.106 -0.435 -0.476 0 -0.106 0.035 -0.188 0.1 -0.258 -0.006 -0.018 -0.041 -0.117 0.012 -0.247 0 0 0.082 -0.024 0.264 0.1 0.076 -0.024 0.159 -0.029 0.241 -0.029s0.164 0.012 0.241 0.029c0.182 -0.123 0.264 -0.1 0.264 -0.1 0.053 0.129 0.018 0.229 0.012 0.252a0.379 0.379 0 0 1 0.1 0.258c0 0.37 -0.223 0.446 -0.434 0.47 0.035 0.029 0.065 0.088 0.065 0.176v0.264c0 0.024 0.018 0.053 0.065 0.047A0.958 0.958 0 0 0 1.92 0.957C1.914 0.429 1.486 0 0.957 0",
    fill: "#9ca3af"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLogo);
export default __webpack_public_path__ + "static/media/github-logo.5efaf2abac303052bbe48c400fdb3a8b.svg";
export { ForwardRef as ReactComponent };